
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { DataService } from './shared/data.service';
import { ImageCarouselComponent } from './imageCarousel/image-carousel.component';
import { HttpModule } from '@angular/http';

import { Ng2CarouselamosModule } from 'ng2-carouselamos';
import { PropertyService } from './shared/property.service';
import { CentralComponent } from './central/central.component';
import { FooterComponent } from './footer/footer.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';

import 'hammerjs';

import { MapComponent } from './map/map.component';
import { ViewingformComponent } from './viewingForm/viewingForm.component';
import { EventService } from './shared/event.service';
import { FormsModule } from '@angular/forms';
import { PhoneValidatorDirective } from './viewingForm/phone-validator.directive';
import { SidebarComponent } from './sidebar/sidebar.component';
import { MatSidenavModule } from '@angular/material';
import { FeaturesComponent } from './features/features.component';

@NgModule({
  declarations: [
    AppComponent,
    ImageCarouselComponent,
    CentralComponent,
    FooterComponent,
    MapComponent,
    ViewingformComponent,
    PhoneValidatorDirective,
    SidebarComponent,
    FeaturesComponent
  ],
  imports: [
    MatSidenavModule,
    BrowserAnimationsModule,
    BrowserModule,
    FormsModule,
    HttpModule,
    Ng2CarouselamosModule,
    RouterModule.forRoot([
      // {path: 'features', component: FeaturesComponent},
      // {path: 'map', component: MapComponent},
      // {path: 'viewingForm', component: ViewingformComponent}
    ])
  ],
  providers: [
    DataService,
    PropertyService,
    EventService
   ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// D:/FLINK/FlinkViewingPageDec2020/NewLandingPage/src/app/app.module.ts